import styled, { css } from 'styled-components'

import { FireSection } from '@nx/fire/section'
import { Heading } from '@nx/fire/typography'

export const StyledHeading = styled(Heading)`
  margin-bottom: 25px;

  ${({ theme }) => theme.media.up.xl} {
    margin-bottom: 37px;
  }
`

export const StyledSection = styled(FireSection)`
  &&& {
    ${({ theme: { spacing } }) => css`
      padding-top: ${spacing.verticalSpacer.small}px;
      padding-bottom: ${spacing.verticalSpacer.small}px;
    `}
  }
`
